import { render, staticRenderFns } from "./UploadType.vue?vue&type=template&id=278a5dba&scoped=true&"
import script from "./UploadType.vue?vue&type=script&lang=js&"
export * from "./UploadType.vue?vue&type=script&lang=js&"
import style0 from "./UploadType.vue?vue&type=style&index=0&id=278a5dba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "278a5dba",
  null
  
)

export default component.exports